import "@pjs/theming/dist/theme.css";
import { injectCss } from "../../../../../../../../node_modules/@pebblepad/pebblepack/runtime/InjectCss.runtime.js";
injectCss(`.uui-authorised-devices-dialog__content{line-height:var(--font-line-height-body)}`);